import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../components/AppLayout'
import { addCoupon, getPlan } from '../logic/plans/action';

const AddCoupons = () => {
    // const selector = useSelector(state=>state.plans);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // useEffect(() => {
    //   getPlan(dispatch);
    // }, [])
    const [data, setdata] = useState({
      coupon:'',
      price:0,
      ispercent:0
    })
    return (
      <AppLayout>
          <div className='flex-1 h-full flex flex-col items-center gap-10 p-10 justify-center'>
          <h1>Add New Discount</h1>
          <div className='w-1/2 flex flex-col items-center gap-4'>
          <input placeholder='Coupon Code' 
          value={data.coupon}
          onChange={(ev=>setdata(prev=>({...prev,coupon:ev.target.value})))}/>
          <input placeholder='Discount Price' 
          value={data.price}
          onChange={(ev=>setdata(prev=>({...prev,price:ev.target.value})))}/>
          <select
          value={data.ispercent}
          onChange={(ev=>setdata(prev=>({...prev,ispercent:ev.target.value})))} 
    className='h-10 outline-none rounded-md px-4 w-full border-blue-800 border' name="Type" id="Type" >
    {/* <option value={2} selected disabled>I</option> */}
    <option value={1} selected>%</option>
    <option value={0}>₹</option>
    
  </select>
          <button
          onClick={()=>addCoupon(dispatch,data,navigate)}
          >ADD Discount Price</button>
          </div>
          </div>
    </AppLayout>
    )
  
}

export default AddCoupons
